import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { getUserName } from "../utils/localStorage";

const firebaseConfigs = {
  Samudragarh: {
    apiKey: process.env.REACT_APP_SAMUDRAGARH_APIKEY,
    authDomain: process.env.REACT_APP_SAMUDRAGARH_AUTHDOMAIN,
    projectId: process.env.REACT_APP_SAMUDRAGARH_PROJECTID,
  },
  Nabadwip: {
    apiKey: process.env.REACT_APP_NABADWIP_APIKEY,
    authDomain: process.env.REACT_APP_NABADWIP_AUTHDOMAIN,
    projectId: process.env.REACT_APP_NABADWIP_PROJECTID,
  }
};

const apps = {};

function getDatabase(region) {
  if (!firebaseConfigs[region]) {
    throw new Error(`Invalid region: ${region}`);
  }

  if (!apps[region]) {
    apps[region] = firebase.initializeApp(firebaseConfigs[region], region);
  }

  return apps[region].firestore();
}

// ✅ THIS is the key function
export function getCurrentDb() {
  const location = getUserName()?.location || "Samudragarh";
  return getDatabase(location);
}
